import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "../data";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-[60] flex flex-col gap-3">
      <motion.a
        data-testid="floating-whatsapp-button"
        href={`https://wa.me/${CONTACT.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
        className="group flex items-center justify-end gap-0 rounded-full bg-[#25D366] p-4 text-[#080C14] shadow-[0_10px_30px_rgba(37,211,102,0.35)] hover:shadow-[0_10px_40px_rgba(37,211,102,0.55)] transition-shadow"
      >
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-xs font-bold uppercase tracking-wider transition-all duration-300 group-hover:max-w-[120px] group-hover:mr-2">
          WhatsApp
        </span>
        <MessageCircle size={22} strokeWidth={2.2} />
      </motion.a>
      <motion.a
        data-testid="floating-call-button"
        href={`tel:${CONTACT.phone1}`}
        aria-label="Call SK Engineering Works"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.55, type: "spring", stiffness: 260, damping: 18 }}
        className="group flex items-center justify-end gap-0 rounded-full bg-amber-500 p-4 text-[#080C14] shadow-[0_10px_30px_rgba(245,158,11,0.35)] hover:shadow-[0_10px_40px_rgba(245,158,11,0.55)] transition-shadow"
      >
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-xs font-bold uppercase tracking-wider transition-all duration-300 group-hover:max-w-[120px] group-hover:mr-2">
          {CONTACT.phone1}
        </span>
        <Phone size={22} strokeWidth={2.2} />
      </motion.a>
    </div>
  );
}
